/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a product group.
 */
import { mapGetters } from 'vuex';
import materialService from './../../../../services/material';
import supplierService from './../../../../services/supplier';
import materialTransformer from './../../../../transformers/material';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';
import materialTypeService from './../../../../services/materialType';
import unitOfMeasureService from './../../../../services/unitOfMeasure';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        materialTypeId: {
          value: '',
          type: 'select',
        },
        unitMeasureId: {
          value: '',
          type: 'select',
        },
        supplierId: {
          value: '',
          type: 'select',
        },
        minimumStockLevel: {
          value: '',
          type: 'number',
        },
      }),
      loading: false,
    };
  },

  created() {
    Promise.all([
      materialTypeService.all(),
      supplierService.all(),
      unitOfMeasureService.all(),
    ]).then(() => {
      this.loading = false;
    });
    this.show();
  },

  computed: {
    ...mapGetters({
      materials: 'allProductGroups',
      materialTypes: 'allMaterialTypes',
      unitOfMeasures: 'allUnitOfMeasures',
      suppliers: 'allSuppliers',
    }),
  },

  methods: {
    /**
     * Method to update the product group.
     */
    update() {
      this.form.loading = true;
      const material = materialTransformer.send(this.form.data());
      materialService.update(store.state.route.params.id, material)
      .then(() => {
        this.form.loading = false;
        this.$message({
          message: this.$t('static.materials.edit.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'production.materials.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the product group object for editing.
     */
    show() {
      this.loading = true;
      materialService.show(store.state.route.params.id).then((material) => {
        this.form.assignData(material);
        this.loading = false;
      });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  watch: {
    materialTypes(types) {
      this.form.setOptions('materialTypeId', types.map(c => (
        {
          id: c.id,
          name: this.$t(`static.materials.types.${this.camalize(c.name)}`),
        }
      )));
    },
    unitOfMeasures(units) {
      this.form.setOptions('unitMeasureId', units.items.map(c => ({
        id: c.id,
        name: this.$t(`static.materials.unitOfMeasures.${this.camalize(c.name)}`),
      })));
    },
    suppliers(suppliers) {
      this.form.setOptions('supplierId', suppliers.items);
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/materials/edit/edit.js